import {
  abbreviateId,
  Card,
  CopyButton,
  EllipsisBoxWithTooltip,
  FormControlSizes,
  SecurityRenderer,
  Table,
  Tbody,
  Td,
  Th,
  Tr,
  type Security,
} from '@talos/kyoko';

interface CustomerTradeContextOverviewProps {
  customer: string;
  customerAccount: string;
  security?: Security;
  symbol: string;
  tradeID: string;
}

export function CustomerTradeContextOverview({
  customer,
  customerAccount,
  security,
  symbol,
  tradeID,
}: CustomerTradeContextOverviewProps) {
  return (
    <Card data-testid="customer-trade-drawer-customer-context">
      <Table>
        <Tbody>
          <Tr>
            <Th>Trade</Th>
            <Td display="flex" alignItems="center" justifyContent="flex-end" gap="spacing4">
              #{abbreviateId(tradeID)}
              <CopyButton size={FormControlSizes.Tiny} value={tradeID} />
            </Td>
          </Tr>
          <CustomerTradeContextRow label="Customer" value={customer} />
          <CustomerTradeContextRow label="Customer Account" value={customerAccount} />
          <Tr>
            <Th>Symbol</Th>
            <Td align="right" maxWidth="0">
              <SecurityRenderer
                symbol={symbol}
                security={security}
                showDescription={false}
                iconSize={12}
                display="inline-flex"
                maxWidth="100%"
                data-testid="customer-trade-context-symbol"
              />
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </Card>
  );
}

function CustomerTradeContextRow({ label, value }: { label: string; value: string }) {
  return (
    <Tr>
      <Th whiteSpace="nowrap">{label}</Th>
      <Td align="right" maxWidth="0">
        <EllipsisBoxWithTooltip textAlign="right">{value}</EllipsisBoxWithTooltip>
      </Td>
    </Tr>
  );
}
